import { render, staticRenderFns } from "./RealTaskList.vue?vue&type=template&id=0525f3e4&"
import script from "./RealTaskList.vue?vue&type=script&lang=js&"
export * from "./RealTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports